export default __webpack_public_path__ + "static/media/project1image3.290c5052.jpg";